<template>
  <div class="withdraw-status">
    <div class="process">
      <div>{{$t(langKey+'.status1')}}</div>
      <div class="active">{{$t(langKey+'.status2')}}</div>
      <div class="disable">{{$t(langKey+'.status3')}}</div>
    </div>
    <div class="btn-submit">
      <router-link replace tag="a" to="./withdraw">{{$t(langKey+'.button')}}</router-link>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { setTitle } from 'components/mixin/title'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      langKey: this.$route.name
    }
  },
  computed: {
    ...mapGetters(['lang'])
  },
  methods: {
  },
  mixins: [setTitle]
}
</script>
<style scoped lang="scss">
  @import "css/def";
  .withdraw-status{
    min-height: 100vh;
    background: #fff;
    color: #333;
    >.process{
      padding: size(70) size(32) 0 size(200);
      font-size: size(30);
      line-height: 1.3;
      >div{
        padding-bottom: size(160);
        position: relative;
        z-index: 1;
        &::before{
          content: ' ';
          display: block;
          position: absolute;
          z-index: 2;
          top: 0;
          bottom: 0;
          left: size(-58);
          width: size(3);
          background-color: #108EE9;

        }
        &:first-child::before{
          top: size(20);
        }
        &:last-child::before{
          height: size(180);
          top: size(-160);
          bottom: auto;
        }
        &::after{
          content: ' ';
          display: block;
          position: absolute;
          z-index: 4;
          top: size(10);
          left: size(-66);
          width: size(18);
          height: size(18);
          -webkit-border-radius: size(18);
          -moz-border-radius: size(18);
          border-radius: size(18);
          background-color: #108EE9;
        }
        &.active{
          color: #108EE9;
          font-weight: 600;
          &:after{
            z-index: 6;
            top: size(-4);
            left: size(-76);
            width: size(40);
            height: size(40);
            background-color: #fff;
            -webkit-background-size: 100% 100%;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAAETklEQVRYR8WYXWwUVRiG3++cXS2NaSAh7CyKVIxGEi+MgdALlBAD8UKvSE0VMLHxJ4oQJWm3iiaNGGS3YiSVRI2VC0hqqmjUe4jGn3AlXphIBUWDdrc1xQtKf3bOec3MUtx2f2ZmO5W53P2+933Od875zswRNPCsPMRVxpgtQmwEsBaQVgAtBG8AcBmQMQHPAvIDoE7ll+IbPCPFqFYSOmGIOv2reZSCpwDcByB8LvA3iEGr3MOj3U3nw3qGMkjn3G0kcgDWhBWuFkfAFeAYle4pdMlokFZduJVvcrk15iiAh4KEov0vlyjcVehODNbLqwmXzs3cS+rPAd4SzThCNHEkP6X3oFdstayqcE6Om2jNFyJoiWDVaOin+fO6A+9XbpgKOK9i1qpT/xOYPyARHB/p1o8DwvIRzoHz1phxzRkR3NxoGRrNI+TlQka/URPOybpfxr/4w+F6OxlKbyx0yenZjGuVu9ouPgkntThRFDlTaFXr8IgYf7p9myFq5zczvNA+FhNyZz6T8NpXCS590N1BwbGYxGvKkPgzeD3LcH5SrfXaiw/nZN2vANy/qHCCEzc16e0TU/YDkjvqeVHxgUJX8qR4h7h1ze8Rz8po4xCcyF/RHegVF+3UznrzLYgNtUQEMjCS0U9KKud2CjEQzS1CdDmYN0s5swtkf/1iyB/5jF4tTtb9EMATEezChzYEVpKXYrHVg/seQFt4x5CRCwDz4agfFCdrRgA6IS2nAdwYGLtAsFIbkWc9uAmAzUGGhJyDUluFpg/EtprxMYD52pSMpLJuUYBEAFxhBnrdeEYuopcJp9l8VBUwLjCPDfKKB3dJgKUBcITI7ny3PuLHVQOMEaxUOHlBUlkzLOAdQdNaGkwNwJjBfDilt3u7NcqbSAVgutnuHrmi+v0GG7qPBZdCYNd7G+I1gK8Gh1+LmAtYlhiuwYZymk4k9TJxssXNgJwMlfJfUAVgjGCey9f5TGKT4D0mnX/MXwCWNwroZM1zAN+J63ymkhcLXfrt0itT1hwmuCcinL9uAfkYYHtsYECRrl41uk8KPtyKt7hGiuZsiH7XAH/UFDmaz+jO0ilx9XFyZgCk/+P1e2TaJNXdY3vl3By4VB9XiDU/A1h2veBIHij0JPfN+s/5NEz1sUOsqXtFsFjghPy4ZFK1XeiVqapwfhPNmn6Azy8WRA3dcSO6baxbfin/v/I6opfKaTJDkDpvHrGSy4Sl3Trak/xuvmz1i5ynmXRutwMAd8bKUSk2bsmHq4HN2RCVeZRUzmZA7l+MFuOtMSuqff5U1p/WeZSpPm6Ate8KeE88VZRp0h5aMpXYX774q2mHutn0bwQuYCfovgTInY1AEigK5LhJqgOzfSxIJxzcrAopqYPuZqXkMUK2ALw1wMD75jhNJZ9xRg16R1IQUKRprSeWfn1yNRJNd0HsbSRaKEhCcBmixpQtDutk8qeLe2UyClB57L8Al/WNbLGuSAAAAABJRU5ErkJggg==');
          }
          &::before{
            background-color: #ccc;
          }
        }
        &.disable{
          color: #ccc;
          &::before{
            background-color: #ccc;
            z-index: 3;
          }
          &:after{
            background-color: #ccc;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/me/withdraw-status.vue